import { render, staticRenderFns } from "./PhysicalProductList.vue?vue&type=template&id=d78c3ffe&scoped=true"
import script from "./PhysicalProductList.vue?vue&type=script&lang=js"
export * from "./PhysicalProductList.vue?vue&type=script&lang=js"
import style0 from "./PhysicalProductList.vue?vue&type=style&index=0&id=d78c3ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78c3ffe",
  null
  
)

export default component.exports